import { cleanRedirectUrl } from '@/assets/script/utils/index.js'

import {
  queryPost,
  queryPostIntegration,
} from '@/graphql/wordpress/query/post.js'
import { queryPosts } from '@/graphql/wordpress/query/posts.js'

export default {
  async asyncData({ app, error, params, redirect, route }) {
    try {
      // Ritorno l'articolo
      const requestPost = await app.apolloProvider.defaultClient
        .query({
          query: queryPost,
          variables: {
            slug: params.post,
          },
        })
        .then(({ data }) => {
          return data
        })

      // Redirect
      const matched = requestPost.redirects.find(
        ({ url }) => url === `/blog${route.path}`
      )
      if (matched) {
        const action = cleanRedirectUrl(matched.action_data)
        redirect(matched.action_code, action)
      }

      if (!requestPost?.postBy) {
        return error({ statusCode: 404 })
      }
      const page = requestPost
      return {
        page,
      }
    } catch (e) {
      console.error(e)
      // return error({ statusCode: 500 })
    }
  },
  computed: {
    seo() {
      const seo = this.$generateTags(
        {
          ...this.page?.postBy?.seo,
          hreflang: this.page?.postBy?.hreflang || [],
        },
        this.$i18n
      )
      return seo
    },
    socialData() {
      const socialData = {
        title: this.page?.postBy?.title,
        description: this.page?.postBy?.seo?.metaDesc?.replace(
          /<a.*>.*?<\/a>/gi,
          ''
        ),
        url: `${process.env.NUXT_ENV_BASE_URL}${this.$route.fullPath}`,
      }
      return socialData
    },
  },
  data: () => ({
    relatedPosts: undefined,
  }),
  async mounted() {
    try {
      const requestPostIntegration = await this.$apollo
        .query({
          query: queryPostIntegration,
          variables: {
            slug: this.$route.params.post,
          },
        })
        .then(({ data }) => data)

      // Assegno gli ADV
      /* this.page.postBy = {
        ...this.page?.postBy,
        advertising: requestPostIntegration?.postBy?.advertising,
      } */
      this.page = requestPostIntegration

      // Ritorno i posts filtrano quelli già presenti nelle categorie sopra
      this.relatedPosts = await this.$apollo
        .query({
          query: queryPosts,
          variables: {
            first: 2,
            where: {
              notIn: this.page?.postBy?.postId,
              categoryIn: this.page?.postBy?.categories?.nodes?.map(
                ({ categoryId }) => categoryId
              ),
            },
          },
        })
        .then(({ data }) => data)
    } catch (e) {
      console.error(e)
      // return this.$nuxt.context.error({ statusCode: 500 })
    }
  },
}
